import { Grid, ToggleButton, ToggleButtonGroup, styled } from "@mui/material";

import { TRADE_SIDE } from "pages/BasicTrade/components/constants";
import { useFormContext } from "react-hook-form";

function ConvertSide({ handleResetButtons }) {
  const { watch, reset } = useFormContext();
  const sideId = +watch("sideId");

  const handleChange = (_, newValue) => {
    const youPay = watch("youPay");
    const youReceive = watch("youReceive");
    handleResetButtons();
    if (newValue) {
      reset({
        youPay: youReceive,
        youReceive: youPay,
        sideId: newValue,
        amountFrom: "",
        amountTo: "",
      });
    }
  };

  return (
    <Grid container my={1}>
      <Grid item xs={12}>
        <ToggleButtonGroupStyle
          color="text"
          value={sideId}
          exclusive
          onChange={handleChange}
        >
          <ToggleButtonStyle
            color={TRADE_SIDE.Buy.color}
            value={TRADE_SIDE.Buy.id}
          >
            Buy
          </ToggleButtonStyle>
          <ToggleButtonStyle
            color={TRADE_SIDE.Sell.color}
            value={TRADE_SIDE.Sell.id}
          >
            Sell
          </ToggleButtonStyle>
        </ToggleButtonGroupStyle>
      </Grid>
    </Grid>
  );
}

const ToggleButtonGroupStyle = styled(ToggleButtonGroup)(({ theme }) => ({
  width: "100%",
  paddingRight: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  borderRadius: "8px !important",
  border: `1px solid ${theme.palette.common.white}10`,
}));

const ToggleButtonStyle = styled(ToggleButton)(({ theme }) => ({
  width: "100%",
  border: "none",
  borderRadius: "8px !important",
  marginLeft: theme.spacing(-2),
  marginRight: theme.spacing(-2),
  color: theme.palette.text.main,
  padding: theme.spacing(0.5),
  lineHeight: 0,
  minHeight: "30px",
  textTransform: "none",
  backgroundColor: theme.palette.modules.input,

  "&.Mui-selected": {
    color: theme.palette.common.white,
    zIndex: 1,
    "&.MuiToggleButton-success": {
      backgroundColor: theme.palette.success.main,
    },

    "&.Mui-error": {
      backgroundColor: theme.palette.error.main,
    },
  },
}));

export default ConvertSide;
